export default __webpack_public_path__ + "static/media/issued-card.b4d1e299.svg";